import { Link } from "@chakra-ui/react";
import { AvailableReportsModal } from "features/reports/available-reports/AvailableReportsModal";
import { useAvailableReportTableRetrieveSuspense } from "gen/endpoints/reports/reports";
import { ReportingRunReadData } from "gen/model/reportingRunReadData";
import { TextTableCellValue } from "gen/model/textTableCellValue";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { DataTable } from "shared/components/table/data/DataTable";
import {
  GetColumnDefFn,
  RenderRowActionsFn,
} from "shared/components/table/data/DataTableTypes";
import { match } from "ts-pattern";

export const AvailableReportsTable: React.FC<{
  onSuccess: (data: ReportingRunReadData) => void;
}> = ({ onSuccess }) => {
  const { t } = useTranslation(["common", "reports"]);

  const { data } = useAvailableReportTableRetrieveSuspense();

  const [requestedReport, setRequestedReport] = useState("");

  const getColumnDef = useCallback<GetColumnDefFn>(
    (props) =>
      match(props.column.id)
        .with("report_name", () => ({ pinned: false }))
        .otherwise(() => undefined),
    [],
  );

  const renderRowActions = useCallback<RenderRowActionsFn>(
    ({ row }) => {
      const reportCell = row.data?.cells.report_name
        .value as TextTableCellValue;
      return {
        type: "buttons",
        actions: (
          <Link
            onClick={() => {
              setRequestedReport(reportCell.text || "");
            }}
          >
            {t("reports:availableTable.runReportButton")}
          </Link>
        ),
      };
    },
    [t],
  );

  return (
    <>
      <DataTable
        data={data}
        getColumnDef={getColumnDef}
        renderRowActions={renderRowActions}
      />
      {!!requestedReport && (
        <AvailableReportsModal
          reportType={requestedReport}
          onCloseComplete={() => setRequestedReport("")}
          onSuccess={onSuccess}
        />
      )}
    </>
  );
};
